import React from "react";
import { Tooltip as BaseTooltip } from 'react-tooltip'
import "react-tooltip/dist/react-tooltip.css";
import cn from "classnames";
import style from "./tooltip.module.scss";

export const Tooltip = ({ ...props }) => {
    return (
        <BaseTooltip {...props}
                        className={cn(props.className, style.baseTooltip)}
                        disableStyleInjection="core"
        />
    );
};
